import _, { isString } from "lodash";

export const getCSVData = (dataObject, overwriteKeys) => {
  if (!dataObject?.length) return [];
  const keys = Object.keys(dataObject[0]);
  const csvString = [
    [...(overwriteKeys || keys)],
    ...dataObject.map((el) => keys.map((key) => el[key])),
  ];
  return csvString;
};

export const capitalize = (str) => {
  if (!str) return "";
  return `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`;
};

export const parseCurrency = (value) => {
  const currencySymbol = window.gz_global_dashboard_vars_currency_symbol || "$";
  let obj = (
    Math.round(typeof value === "number" ? value : parseFloat(value || 0, 10)) /
    100
  ).toFixed(2);
  if (obj.split(".")[0].length > 3) {
    obj = obj.replace(/\d(?=(\d{3})+\.)/g, "$&,");
  }
  return `${currencySymbol || "$"}${obj || 0}`;
};
// export const parseCurrency = (value) => (value / 100).toFixed(2);
// export const roundNumber = (value) => Math.round(value).toFixed(2);
export const roundNumber = (value) => value.toFixed(2);
export const isPercent = (value) => (value / 200) * 100;

export const parsePercent = (value) => {
  if (value === "tiered") {
    return value;
  }
  if (!_.isNil(value)) {
    return `${value}%`;
  }
  return "";
};

const cleanURL = (x) => {
  if (x.includes("http://") || x.includes("https://")) return x;
  return `https://${x}`;
};

export const cleanForId = (x) => x?.replace(/\./g, "");

export const getRootDomain = (urlParam) => {
  const url =
    typeof urlParam === "string" ? new URL(cleanURL(urlParam)) : urlParam;

  const domain = url.hostname;
  const elems = domain.split(".");
  const iMax = elems.length - 1;

  const elem1 = elems[iMax - 1];
  const elem2 = elems[iMax];

  const isSecondLevelDomain = iMax >= 3 && (elem1 + elem2).length <= 5;
  return `${
    (isSecondLevelDomain ? `${elems[iMax - 2]}.` : "") + elem1
  }.${elem2}`;
};

export const parseJSON = (x, returnNull = false) => {
  try {
    if (!isString(x)) return x;
    return JSON.parse(x);
  } catch {
    if (returnNull) return null;
    return x;
  }
};

// function closePrint() {
//   document.body.removeChild(this.__container__);
// }

// function setPrint() {
//   this.contentWindow.__container__ = this;
//   this.contentWindow.onbeforeunload = closePrint;
//   this.contentWindow.onafterprint = closePrint;
//   this.contentWindow.focus(); // Required for IE
//   this.contentWindow.print();
// }

export const printPage = (sURL) => {
  const iframe = document.createElement("iframe"); // load content in an iframe to print later
  document.body.appendChild(iframe);

  iframe.style.display = "none";
  iframe.src = sURL;
  iframe.onload = () => {
    setTimeout(() => {
      iframe.focus();
      iframe.contentWindow.print();
    }, 1);
  };
  // const hideFrame = document.createElement("iframe");
  // hideFrame.onload = () => {
  //   setTimeout(setPrint, 1);
  // };
  // hideFrame.style.position = "fixed";
  // hideFrame.style.right = "0";
  // hideFrame.style.bottom = "0";
  // hideFrame.style.width = "0";
  // hideFrame.style.height = "0";
  // hideFrame.style.border = "0";
  // hideFrame.src = sURL;
  // document.body.appendChild(hideFrame);
};

const filterServicesCategoriesAll = (cat) =>
  [0, 1, 2, 3, 4].includes(cat.categorystatus) &&
  (!cat.deleted_at || cat.deleted_at === "0000-00-00 00:00:00");
const filterProductsCategoriesAll = (cat) =>
  [0, 1, 2, 3, 4].includes(cat.categorystatus) &&
  (!cat.deleted_at || cat.deleted_at === "0000-00-00 00:00:00");

const filterServicesAll = (item) =>
  [0, 1, 2, 3].includes(item.servicestatus) &&
  (!item.deleted_at || item.deleted_at === "0000-00-00 00:00:00");

const filterProductsAll = (item) =>
  [0, 1, 2, 3].includes(item.productstatus) &&
  (!item.deleted_at || item.deleted_at === "0000-00-00 00:00:00");

const filterServicesCategories = (cat) =>
  [0, 1, 2, 4].includes(cat.categorystatus) &&
  (!cat.deleted_at || cat.deleted_at === "0000-00-00 00:00:00");
const filterProductsCategories = (cat) =>
  [0, 1, 2, 4].includes(cat.categorystatus) &&
  (!cat.deleted_at || cat.deleted_at === "0000-00-00 00:00:00");

const filterServices = (item) =>
  [0, 1, 2].includes(item.servicestatus) &&
  (!item.deleted_at || item.deleted_at === "0000-00-00 00:00:00");

const filterProducts = (item) =>
  [0, 1, 2].includes(item.productstatus) &&
  (!item.deleted_at || item.deleted_at === "0000-00-00 00:00:00");

export const formatServiceCategories = (categories) =>
  categories
    ?.filter(filterServicesCategories)
    ?.map((x) => ({ ...x, services: x.services?.filter(filterServices) }));

export const formatProductCategories = (categories) =>
  categories
    ?.filter(filterProductsCategories)
    ?.map((x) => ({ ...x, products: x.products?.filter(filterProducts) }));

export const formatServiceCategoriesAll = (categories) =>
  categories
    ?.filter(filterServicesCategoriesAll)
    ?.map((x) => ({ ...x, services: x.services?.filter(filterServicesAll) }));

export const formatProductCategoriesAll = (categories) =>
  categories
    ?.filter(filterProductsCategoriesAll)
    ?.map((x) => ({ ...x, products: x.products?.filter(filterProductsAll) }));

export const LEGACY_PREPAID_NAME = "Legacy Prepaid Items";
export const THIRD_PARTY_PREPAID_NAME = "Third-party Prepaid Items";

export const isLegacyPrepaid = (x) => x?.giftcard === 2;
export const isThirdPartyPrepaid = (x) => x?.giftcard === 3;

export const defaultPayPeriod = "month";
